var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shownotice)?_c('md-notice-bar',{staticClass:"noticetop",attrs:{"type":"warning","mode":"closable","icon":"info","multi-rows":""},on:{"close":_vm.closenotice}},[_c('div',{on:{"click":_vm.showmessage}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe7332a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noticetop.vue
// module id = null
// module chunks = 